/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";
const AccountBookings = () => {
    const embeddedId = "2331b962-19fa-4bcf-ac48-4539c325f91b";
    const rsl = [];
    const title = "Account Bookings";
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default AccountBookings;
